import React from 'react';
import SimmsSelect from "./SimmsSelect";
import "./tableSizeSelector.css";

function TableSizeSelector({handlePageSizeChange, pageInfo}) {

    const handleValueChange = (value) => {
        handlePageSizeChange(value);
    };

    const options =[
        {id :10, name:10, value:"10"},
        {id :20, name:20, value:"20"},
        {id :50, name:50, value:"50"},
        {id :100, name:100, value:"100"},
        {id :1000, name:1000, value:"1000"}
    ]

    //SimmsSelect 에 스타일 옵션 넘기는 예시
    const style ={
        label:{},
        option:{}
    }
    return (
        <div className="table-size-selector">
            <SimmsSelect
                variant="tableSize"
                onChange={handleValueChange}
                options={options}
                data={pageInfo?.size ?? 20}
                style={style}
            />
        </div>
    );
}

export default TableSizeSelector;